module.exports = __webpack_public_path__ + "static/img/lagel_QRCode.b9a9fad4.png";